import React, { useState } from "react";
import { Box, Button, useTheme } from "@mui/material";
import { Search as SearchIcon } from "lucide-react";
import InputCst from "@components/InputCst/InputCst";

interface SearchBarProps {
  initialValue?: string;
  onSubmit: (value: string) => void;
  placeholder: string;
  buttonLabel: string;
  filtersSlot?: React.ReactNode;
}

const SearchBar: React.FC<SearchBarProps> = ({
  initialValue = "",
  onSubmit,
  placeholder,
  buttonLabel,
  filtersSlot,
}) => {
  const theme = useTheme();
  const [value, setValue] = useState(initialValue);

  const handleSubmit = () => onSubmit(value.trim());

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1.5,
        alignItems: "center",
        width: "100%",
      }}
    >
      <Box
        sx={{
          flex: 1,
          "& .MuiFormControl-root": {
            minWidth: "0 !important",
            width: "100% !important",
          },
          "& .MuiOutlinedInput-root": { borderRadius: "8px" },
          "& .MuiOutlinedInput-notchedOutline": { borderRadius: "8px" },
        }}
        onKeyDown={handleKeyDown}
      >
        <InputCst
          id="searchable-multi-select-input"
          label={placeholder}
          value={value}
          onChange={(e: any) => setValue(e.target.value)}
          endAdornment={
            <SearchIcon size={16} color={theme.palette.text.tertiary} />
          }
        />
      </Box>
      <Button
        onClick={handleSubmit}
        variant="contained"
        sx={{
          textTransform: "none",
          fontWeight: 700,
          borderRadius: "8px",
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          flexShrink: 0,
          "&:hover": { backgroundColor: theme.palette.primary.dark },
        }}
      >
        {buttonLabel}
      </Button>
      {filtersSlot}
    </Box>
  );
};

export default SearchBar;
